import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import State from "../../../../domain/entities/State";
import { ImageConfigs } from "../../../../domain/entities/Configs";
import { useDispatch } from "react-redux";
import { getImage } from "../../../redux/actions/administrator";
import { useAuth } from "../../../hooks/useAuth";
import User from "../../../../domain/entities/User";

interface ImageLoaderProps {
  fileName: ImageConfigs;
  alt?: string;
  style?: React.CSSProperties;
}

const ImageLoader: React.FC<ImageLoaderProps> = ({
  fileName,
  alt,
  ...rest
}) => {
  const [imageSrc, setImageSrc] = useState<string | null | undefined>(null);
  const { user }: { user: User } = useAuth()!;
  const dispatch: any = useDispatch();
  const siteImages = useSelector(
    (state: State) => state.administrator.siteImages
  );

  useEffect(() => {
    if (siteImages?.[fileName]) {
      setImageSrc(siteImages?.[fileName]);
    } else {
      setImageSrc(null);
      if (user && user.organization.id) {
        dispatch(getImage(user.organization.id, fileName));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileName]);

  useEffect(() => {
    if (!imageSrc) {
      setImageSrc(siteImages?.[fileName]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteImages]);

  if (!imageSrc) {
    return null;
  } else if (imageSrc === "ERROR") {
    return null;
  }

  return (
    <>
      <img
        src={imageSrc}
        alt={alt}
        {...rest}
        onError={() => setImageSrc("ERROR")}
      />
    </>
  );
};

export default ImageLoader;
